import React from 'react'
import AuthErrorFallback from '../components/AuthErrorFallback/AuthErrorFallback'

const AuthError = () => <AuthErrorFallback />

export default AuthError
